<div class="modal-bg members-dialog-backdrop">
    <div class="form modal-dialog-container members-dialog-container">

        <div class="dialog-header members-dialog-header">
            <div class="header-copy">
                <span class="dialog-eyebrow">Workspace</span>
                <h2>Members of project {{ this.project.name }}</h2>
                <p>Manage who can access this project and which role each member has.</p>
            </div>
            <div class="dialog-close-btn members-dialog-close-btn" (click)="closeDialog()">
                <i class="fa fa-times" aria-hidden="true"></i>
            </div>
        </div>

        <div class="members-dialog-content">
            <div *ngIf="canCreateInviteCodes()" class="member-invite-panel">
                <div>
                    <h3>Invite new members</h3>
                    <p>Create one-use invitation codes.</p>
                </div>
                <button class="member-invite-btn" type="button" (click)="showInviteCodesDialog()">
                    <i class="fa fa-envelope" aria-hidden="true"></i>
                    <span>Invitation codes</span>
                </button>
            </div>
            <app-manage-project-members-form [project]="project"></app-manage-project-members-form>
        </div>
    </div>
</div>
